<template>
    <div>
        <link rel="stylesheet" :href="styleTheme" type="text/css">

        <ckeditor :editor="editor" 
            v-model="editorValue" 
            @ready="editorReady"
            :config="editorConfig"></ckeditor>
    </div>
</template>

<script>

import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import '@ckeditor/ckeditor5-theme-lark';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline';
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ImagePlugin from '@ckeditor/ckeditor5-image/src/imageinline';
import ImageInsertPlugin from '@ckeditor/ckeditor5-image/src/imageinsert';
import SubScriptPlugin from  '@ckeditor/ckeditor5-basic-styles/src/subscript';
import SuperScriptPlugin from  '@ckeditor/ckeditor5-basic-styles/src/superscript';
import AlignmentPlugin from  '@ckeditor/ckeditor5-alignment/src/alignment';
import FontSizePlugin from  '@ckeditor/ckeditor5-font/src/fontsize';
import FontColorPlugin from  '@ckeditor/ckeditor5-font/src/fontcolor';
import ListStylePlugin from '@ckeditor/ckeditor5-list/src/liststyle';
import TablePlugin from '@ckeditor/ckeditor5-table/src/table';
import TableToolbarPlugin from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import BlockQuotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import CodeBlockPlugin from '@ckeditor/ckeditor5-code-block/src/codeblock';
import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert';
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';

import LegacyCode from '../../modules/ckeditor5-legacycode/src/legacycode';
import EmptyBreak from '../../modules/ckeditor5-emptybreak/src/emptybreak';
import CustomParagraphPlugin from '../../modules/ckeditor5-paragraph/src/paragraph'; 
import ImageWrapperPlugin from '../../modules/ckeditor5-imagewrapper/src/imagewrapper'; 

import Emoji from '../../modules/ckeditor5-emoji/src/emoji';
import EmojiMain from '../../modules/ckeditor5-emoji/src/emoji-main';

// TODO: Uncomment to allow CK Inspector for better debugging
//import CKEditorInspector from '@ckeditor/ckeditor5-inspector';

import api from '../../api/api';

import '../../../public/styles/style-ckeditor-base.css';


const toolbar = [ 'bold', 'italic', 'underline', '|', 'strikethrough', 'subscript', 'superscript', '|', 
    'alignment:left', 'alignment:center', 'alignment:right', '|', 'fontsize', 'fontcolor', '|',
    'bulletedList', 'numberedList', '|', 'insertTable', 'codeblock', 'blockquote', '|', 'link', 'emoji', 'insertImage', 'sourceEditing', 'undo', 'redo' ];
const plugins = [  LegacyCode,
                        EmptyBreak,
                        EssentialsPlugin,
                        ImagePlugin,
                        ImageInsertPlugin,
                        ImageWrapperPlugin,
                        BoldPlugin,
                        ItalicPlugin,
                        UnderlinePlugin,
                        StrikethroughPlugin,
                        SubScriptPlugin,
                        SuperScriptPlugin,
                        LinkPlugin,
                        CustomParagraphPlugin,
                        AlignmentPlugin,
                        FontSizePlugin,
                        FontColorPlugin,
                        SourceEditing,
                        ListStylePlugin,
                        TablePlugin,
                        TableToolbarPlugin,
                        BlockQuotePlugin,
                        CodeBlockPlugin,
                        Emoji,
                        EmojiMain,
                        ImageInsert,
                        SimpleUploadAdapter,
                ];

const fontSizeConfig = {
	options: [ 
        {
            title: '1',
            model: '10px'
		},
		{
            title: '2',
            model: '13px'
		},
		{
            title: '3',
            model: '16px'
		},
		{
            title: '4',
            model: '18px'
		},
		{
            title: '5',
            model: '24px'
		},
		{
            title: '6',
            model: '32px'
		},
		{
            title: '7',
            model: '48px'
		}
     ],
	supportAllValues: true
};

export default {
    name: "HtmlEditor",
    props: [ "options", "value" ],
    components: {
        ckeditor: CKEditor.component,
        ClassicEditor,
    },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: toolbar
                },
                plugins: plugins,
                simpleUpload: {
                    uploadUrl: `${api.baseUrl()}/attachments/v2/attach`,

                    // Enable the XMLHttpRequest.withCredentials property.
                    withCredentials: false,

                    // Headers sent along with the XMLHttpRequest to the upload server.
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                },
                fontSize: fontSizeConfig
            },
            editorValue: "",

            isInitialized: false,
            bufferValue: "",
            styleTheme: localStorage.getItem('theme') === 'dark' ?
                "/styles/style-ckeditor-dark.css" : 
                "/styles/style-ckeditor-light.css"
        }
    },

    watch: {
        editorValue() {
            this.$emit("input", this.editorValue);
        },
        value() {
            if(!this.isInitialized) {
                this.bufferValue = this.value; 
            }
            else {
                this.editorValue = this.value;
            }
        },
    },

    methods: {      
        editorReady(/*editor*/) {
            // TODO: Uncomment to support CK Inspector for better debugging
            //CKEditorInspector.attach(editor);
            
            this.isInitialized = true;
            if (this.bufferValue) {
               this.editorValue = this.bufferValue; 
            }
        },
    },

    mounted() {
    }
}
</script>

